import { render, staticRenderFns } from "./FormUserReport.vue?vue&type=template&id=bf7d351c"
import script from "./FormUserReport.vue?vue&type=script&lang=js"
export * from "./FormUserReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/CoreProductivity.Backoffice.Mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bf7d351c')) {
      api.createRecord('bf7d351c', component.options)
    } else {
      api.reload('bf7d351c', component.options)
    }
    module.hot.accept("./FormUserReport.vue?vue&type=template&id=bf7d351c", function () {
      api.rerender('bf7d351c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/pages/form/FormUserReport.vue"
export default component.exports